"use strict";import{Checkbox as e}from"./src/Checkbox.js";import{defineElement as o}from"@spectrum-web-components/base/src/define-element.js";o("sp-checkbox",e);
//# sourceMappingURL=sp-checkbox.js.map
